module.exports = __webpack_public_path__ + "img/sample.c05227d9.png";